module.exports = __webpack_public_path__ + "img/III-24.652ea634.svg";